import { Injectable, InjectionToken } from "@angular/core";
import { IStorageHandler } from "./storage-handler.interface";
import { NativeStorage } from "@ionic-native/native-storage";
import { Platform } from "ionic-angular";
import { NativeStorageHandler } from "./handlers/native-storage-handler";
import { LocalStorageHandler } from "./handlers/local-storage-handler";
import { IStorage } from "./storage.interface";

@Injectable()
export class StorageService implements IStorage {

    private storage: IStorageHandler;

    constructor(protected nativeStorage: NativeStorage,
                protected plt: Platform,
                protected key: string) {
        this.initializeStorages();
    }

    get(key: string): Promise<any> {
        return this.storage.getItem(key);
    }

    set(key: string, value: any): Promise<any> {
        return this.storage.setItem(key, value);
    }

    remove(key: string): Promise<any> {
        return this.storage.removeItem(key);
    }

    clear(): Promise<null> {
        return this.storage.clear();
    }

    length(): Promise<number> {
        return this.storage.length();
    }

    keys(): Promise<Array<string>> {
        return this.storage.keys();
    }

    forEach(iteratorCallback: (value: any, key: string, iterationNumber: Number) => any): Promise<null> {
        return this.storage.forEach(iteratorCallback);
    }

    private initializeStorages(): void {
        if (this.isMobile() && !this.isMobileWeb()) {
            this.initializeNativeStorages();
        } else {
            this.initializeLocalStorages();
        }
    }

    private initializeNativeStorages(): void {
        this.storage = new NativeStorageHandler(this.key, this.nativeStorage);
    }

    private initializeLocalStorages(): void {
        this.storage = new LocalStorageHandler(this.key);
    }

    private isCordovaAvailable(): boolean {
        return this.plt.is("cordova");
    }

    private isMobile(): boolean {
        return this.plt.is("mobile");
    }

    private isMobileWeb(): boolean {
        return this.plt.is("mobileweb");
    }
}

export const STATE_STORAGE_TOKEN = new InjectionToken<StorageService>("state-storage-token");
export const CHANGE_LOG_STORAGE_TOKEN = new InjectionToken<StorageService>("change-log-storage-token");

export const STORAGE_PROVIDERS = [
    {
        provide: STATE_STORAGE_TOKEN,
        useFactory: ((nativeStorage: NativeStorage, platform: Platform) => {
            return new StorageService(nativeStorage, platform, "vas-state");
        }),
        deps: [NativeStorage, Platform]
    },
    {
        provide: CHANGE_LOG_STORAGE_TOKEN,
        useFactory: ((nativeStorage: NativeStorage, platform: Platform) => {
            return new StorageService(nativeStorage, platform, "vas-changelog");
        }),
        deps: [NativeStorage, Platform]
    }
];



// WEBPACK FOOTER //
// ./src/core/services/storage/storage.service.ts